import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/styles';
import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material';
import Card from './Card'
import 'react-responsive-modal/styles.css';
import Spinner from './Spinner'
import UserMenu from './UserMenu'

const useStyles = makeStyles({
  gridContainer: {
    paddingLeft: '20px',
    paddingRight: '20px'
  }
})

function Landing(props) {

  // console.log('lndg props', props)
  let content = '';
  const { user, userId, userName, userEmail } = props
  const [salons, setSalons] = useState([])
  const classes = useStyles()
  const salonUrl = (process.env.REACT_APP_SERVER)
    ? `https://salonserver-k8m8.onrender.com/salons`
    : `http://localhost:3001/salons`

  useEffect(() => {
    axios.get(salonUrl,
    )
      .then(({ data }) => {
        console.log('salons data', data)
        setSalons(data)
      })

  }, [])

  return (
    <>
      <Typography
        variant="h6"
        align="center"
        sx={{
          fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, // responsive font
          fontWeight: 600,
          marginY: 2
        }}
      >
        Choose Your Salon to Book Your Service
      </Typography>
      {
        content = salons.length === 0 ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <Grid container spacing={2} className={classes.gridContainer} justify="center">
            {salons.map(salon => (
              // console.log('salon in Landing:', salon),
              <Grid item xs={12} sm={6} key={salon.id}>
                <Card salon={salon} user={user} userId={userId} userName={userName} userEmail={userEmail} userMobile={props.userMobile} />
              </Grid>
            ))}
          </Grid>
        )}
    </>
  )
}

export default Landing